export default {
  dashboard: '仪表盘',
  about: '关于',
  workbench: '工作台',
  analysis: '分析页',
};
